// تقسيم الجدول إلى صفحات معروفة العدد + ترقيم الصفحات + خانة التوقيع والاعتماد.
import { esc } from "./reportFormat";

const PER_PAGE = 16;

export const chunk = (rows, size = PER_PAGE) => {
  const pages = [];
  for (let i = 0; i < rows.length; i += size) pages.push(rows.slice(i, i + size));
  return pages.length ? pages : [[]];
};

export const pageFoot = (index, total, L) =>
  `<div class="pagefoot">${esc(L.pageOf.replace("{i}", index).replace("{n}", total))}</div>`;

export const signature = (L) =>
  `<div class="sign">
    <div class="sign-title">${esc(L.signTitle)}</div>
    <div class="sign-row">
      ${L.signRoles.map((role) => `<div class="sign-box"><div class="sign-role">${esc(role)}</div>
        <div class="sign-line"></div><div class="sign-hint">${esc(L.signNameDate)}</div></div>`).join("")}
    </div>
    <div class="sign-note">${esc(L.signNote)}</div>
  </div>`;
